// Types
import { IPayPeriod, IStatus } from "@/Common/api/types/CommissionCycle";
import { resolveDisabledPositionsByStatus } from "@/Washouts/helpers/resolveDisabledPositionsByStatus";
import PositionsDialog from "../PositionsDialog";
import { TInput } from "@/Washouts/types/PositionsDialog";

interface IRequestReviewDialogProps {
	openPositionsSelector: boolean;
	setOpenPositionsSelector: (value: boolean) => void;
	positionStatuses?: IStatus[];
	disabledPositions?: string[];
	disabledPartnerPositions?: string[];
	reviewPositions: (input: TInput) => void;
	commissionCycleId?: string;
	payPeriod?: IPayPeriod;
	partnerPayPeriod?: IPayPeriod | null;
}

const allowedStatuses = ["PENDING"];

const RequestReviewDialog = (props: IRequestReviewDialogProps) => {
	const {
		openPositionsSelector,
		setOpenPositionsSelector,
		commissionCycleId,
		payPeriod,
		partnerPayPeriod,
		positionStatuses,
		disabledPositions = [],
		disabledPartnerPositions = [],
		reviewPositions,
	} = props;

	const disabledPositionsByStatus = resolveDisabledPositionsByStatus({
		positionStatuses,
		allowedStatuses,
	});

	const disabledPartnerPositionsByStatus = resolveDisabledPositionsByStatus({
		positionStatuses: partnerPayPeriod?.positionStatus,
		allowedStatuses,
	});

	const currentDisabledPositions = [...new Set([...disabledPositions, ...disabledPositionsByStatus])];
	const partnerDisabledPositions = [...new Set([...disabledPartnerPositions, ...disabledPartnerPositionsByStatus])];

	const handleClosePositionsSelector = () => {
		setOpenPositionsSelector(false);
	};

	const currentPayPeriod = {
		payPeriod,
		commissionCycleId,
		disabledPositions: currentDisabledPositions,
	};
	const partnerPayPeriodInfo = {
		payPeriod: partnerPayPeriod,
		disabledPositions: partnerDisabledPositions,
		commissionCycleId: partnerPayPeriod?.cycleId,
	};

	return (
		<PositionsDialog
			open={openPositionsSelector}
			setOpenPositionsSelector={setOpenPositionsSelector}
			closePositionsSelector={handleClosePositionsSelector}
			currentPayPeriod={currentPayPeriod}
			partnerPayPeriod={partnerPayPeriodInfo}
			action={reviewPositions}
			isUsingCallback={true}
			layoutDialogProps={{ title: "Review Positions", btnConfirmText: "Review" }}
		></PositionsDialog>
	);
};

export default RequestReviewDialog;
